// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { FacebookPixelUtils } from "../../../../../../io/hyperify/core/facebook/FacebookPixelUtils";
import { ShoppingCartUtils } from "../../../../../../io/hyperify/core/store/utils/ShoppingCartUtils";
import { Currency } from "../../../../../../io/hyperify/core/types/Currency";
import { FACEBOOK_PIXEL_ID } from "../../../../core/constants/ads";
import {
    CART_ARTICLE_CLASS_NAME
} from "../../../../core/constants/className";
import {
    T_CART_VIEW_CONTENT,
    T_CART_VIEW_NO_ITEMS_CONTENT,
    T_CART_VIEW_ORDER_BUTTON_LABEL,
    T_CART_VIEW_TITLE
} from "../../../../core/constants/translation";
import { ComponentNodeMap, ComponentUtils } from "../../../../../../io/hyperify/frontend/components/utils/ComponentUtils";
import React, { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { NEW_ORDER_ROUTE } from "../../../../core/constants/route";
import { FacebookPixel } from "../facebookPixel/FacebookPixel";
import { CartDetails } from "./CartDetails";
import { ShoppingCart } from "../../../../../../io/hyperify/core/store/types/cart/ShoppingCart";
import { StoreCartService } from "../../../../../../io/hyperify/core/StoreCartService";
import { ShoppingCartItem } from "../../../../../../io/hyperify/core/store/types/cart/ShoppingCartItem";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./CartArticle.scss";

export interface CartArticleProps {
    readonly t: TranslationFunction;
    readonly className?: string;
    readonly cart : ShoppingCart;
}

export function CartArticle (props: CartArticleProps) {

    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;
    const cart = props?.cart;
    const cartItems = cart?.items ?? [];
    const cartItemsCount = cartItems.length ?? 0;
    const totalSum: number = ShoppingCartUtils.getTotalSum(cartItems);

    const paramBlocks : ComponentNodeMap = {
        ITEMS: cartItemsCount
    };

    const description: ReactNode[] = t( cartItemsCount > 0 ? T_CART_VIEW_CONTENT : T_CART_VIEW_NO_ITEMS_CONTENT).split(/\n+/);

    return (
        <article className={CART_ARTICLE_CLASS_NAME + (className ? ` ${className}` : "")}>

            <h2>{t(T_CART_VIEW_TITLE)}</h2>

            {ComponentUtils.prepareParagraphNodes(t, description, paramBlocks)}

            <CartDetails
                className={CART_ARTICLE_CLASS_NAME + "-items"}
                t={t}
                cart={cart}
                onRemove={(item: ShoppingCartItem) => {
                    StoreCartService.removeProduct(item.product, item.price);
                }}
            />

            <div className={CART_ARTICLE_CLASS_NAME + "-buttons"}>
                {cartItemsCount !== 0 ? (
                    <NavLink to={NEW_ORDER_ROUTE} className={"button-link button buy-button"}>{t(T_CART_VIEW_ORDER_BUTTON_LABEL)}</NavLink>
                ) : null}
            </div>

            {cartItems?.length > 0 ? (
                <FacebookPixel url={FacebookPixelUtils.getAddToCartURL(FACEBOOK_PIXEL_ID, totalSum, Currency.EUR )} />
            ) : null}

        </article>
    );

}
